import { onAuthStateChanged } from "firebase/auth";
import { collection, onSnapshot } from "firebase/firestore";
import { auth, db } from "../firebase";

export const SUPER_ADMIN_UID = "V1isGtif6naFawKKg3m224hoaOk2";

// Shared by the /adm route and its editors. Firestore Rules enforce server access.
export function watchAdminAccess(callback) {
  let stopAdmins;
  let generation = 0;
  const emit = (user, state = {}) => callback({
    user,
    loading: false,
    allowed: false,
    isSuperAdmin: false,
    error: null,
    ...state,
  });
  const stopAuth = onAuthStateChanged(auth, user => {
    const current = ++generation;
    stopAdmins?.();
    stopAdmins = undefined;
    if (!user) {
      emit(null);
      return;
    }
    if (user.uid === SUPER_ADMIN_UID) {
      emit(user, { allowed: true, isSuperAdmin: true });
      return;
    }
    if (typeof user.email !== "string" || !user.email) {
      emit(user);
      return;
    }
    emit(user, { loading: true });
    stopAdmins = onSnapshot(collection(db, "admin"), snapshot => {
      if (current !== generation) return;
      emit(user, {
        allowed: snapshot.docs.some(record => record.data().email === user.email),
      });
    }, error => {
      if (current === generation) emit(user, { error });
    });
  });
  return () => {
    generation++;
    stopAuth();
    stopAdmins?.();
  };
}
